export { default as animationFrame } from './common/animation-frame';
export { default as Class } from './common/class';
export { default as htmlEncode } from './common/html-encode';
export { default as logToConsole } from './common/log-to-console';
export { default as Observable } from './common/observable';
export { default as saveAs } from './common/save-as';
export { default as support } from './common/support';
export { default as template } from './common/template';
export { default as throttle } from './common/throttle';

export * from './common/color';




//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-drawing/dist/es/common.js
// module id = ../../../../@progress/kendo-drawing/dist/es/common.js
// module chunks = vendor